function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\u77E9\u5F62");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u5236\\u4F5C-\\u56FE\\u6587\\u5236\\u4F5C-\\u5B57\\u95F4\\u8DDD",
  transform: "translate(-1111.000000, -258.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5BCC\\u6587\\u672C\\u6846",
  transform: "translate(330.000000, 215.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-6",
  transform: "translate(118.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u8868\\u683C",
  transform: "translate(663.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-4",
  transform: "translate(2.500000, 3.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,0 C14.5522847,-1.01453063e-16 15,0.44771525 15,1 L15,1 L15,12 C15,12.5522847 14.5522847,13 14,13 L14,13 L1,13 C0.44771525,13 -1.13619202e-13,12.5522847 -1.13686838e-13,12 L-1.13686838e-13,12 L-1.13686838e-13,1 C-1.13754473e-13,0.44771525 0.44771525,1.01453063e-16 1,0 L1,0 Z M13.65,1.4 L1.4,1.4 L1.4,11.65 L13.65,11.65 L13.65,1.4 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#333333",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.4,4.01710075 L13.65,4.01710075 M1.4,7.83355038 L13.65,7.83355038 M5.2,4.5 L5.2,11.7 M10,4.5 L10,11.65",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  stroke: "#333333",
  strokeWidth: 1.2
})))))));

var SvgEditorTable = function SvgEditorTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditorTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editor_table.8cf9009d.svg";
export { ForwardRef as ReactComponent };